var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.705566,
    y1: 3.51423,
    x2: 30.507,
    y2: 3.51423,
    stroke: "#F2F3F4",
    strokeWidth: 0.573105
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.705566,
    y1: 12.6846,
    x2: 30.507,
    y2: 12.6846,
    stroke: "#F2F3F4",
    strokeWidth: 0.573105
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.705566,
    y1: 21.8536,
    x2: 30.507,
    y2: 21.8536,
    stroke: "#F2F3F4",
    strokeWidth: 0.573105
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.09157,
    cy: 3.09157,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.09157,
    cy: 3.09157,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.09157,
    cy: 3.09157,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2825,
    cy: 13.0256,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2825,
    cy: 13.0256,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2825,
    cy: 13.0256,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7682,
    cy: 21.5398,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7682,
    cy: 21.5398,
    r: 2.12868,
    fill: "#F2F3F4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7682,
    cy: 21.5398,
    r: 2.12868,
    fill: "#F2F3F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.7a83fd1599e670a0582d2329c290345b.svg";
export { ForwardRef as ReactComponent };